const prefix = 'date-range-picker';

export const DateRangePickerTestAttributes = {
    previousMonthButton: `${prefix}-previous-month`,
    nextMonthButton: `${prefix}-next-month`,
};
